@for (modal of modals; track modal; let index = $index) {
    <div class="modalWrapper" [ngClass]="modal.data?.type" appFocusTrap [tabIndex]="index" [isContainerFocusableByKeyboard]="false">
        <div class="modalOverlay" (click)="closeModalByOverlay(index)"></div>
        <div class="modalContent">
            <ng-container #modalContentContainer />
        </div>
    </div>
}
